export function getModal() {
  return this.getRoot()?.Modal
}

export function getModalData(key) {
  const data = this.getModal()?.data
  if (key) {
    return data?.[key]
  }
  return data
}

// Legacy router-driven modal opener. Renamed 2026-06-01 from `openModal`
// to `openRouterModal` so the canonical name (`el.call('openModal', …)`)
// frees up for the @symbo.ls/windows API. Callers across shared/pages/*
// and shared/components/* updated to use the explicit name. The dispatch
// table previously had THREE openModal exports competing (this one,
// canvas/methods/openModal, and @symbo.ls/windows openModal) which
// silently broke confirmDialog and any new windows-API caller — see
// tickets/smbls.md "ModalLayer reactivity" for the framework-side
// reactivity bug that surfaced this collision.
//
// The canvas-v2 `/settings` shim that previously lived in
// canvas/methods/openModal is inlined below so this single function
// covers both surfaces.
export async function openRouterModal(key, val, opts = {}) {
  const el = this

  // Canvas v2 surfaces route `/settings` to the in-canvas settings overlay
  // instead of opening a routed modal — used to live in canvas/methods/
  // openModal as a name-shadow shim; folded here to drop the name clash.
  if (key === '/settings' && el.call?.('isCanvasV2')) {
    el.call('toggleCanvasSettings')
    return
  }

  const root = el.getRoot()
  const Modal = root.Modal
  let FoundModal

  // if () {
  if (key && this.getCanvasScope()) this.getCanvasScope().modal = key

  const modalKey = key || val?.key || this.getWindow('modal')
  const content = Modal.routes[modalKey]
  if (content) {
    this.getRootState().activeModal = modalKey
    FoundModal = content
  } else {
    const modalParams = el.call('findModal')
    // if (val?.key) this.router(val?.key)
    if (!modalParams || opts.forcePreviewUpdate) return
    this.getRootState().activeModal =
      modalParams.beforeLastRoute || modalParams.lastRoute
    FoundModal = modalParams.FoundModal
  }

  if (FoundModal) {
    root.state.activeModal = modalKey
    if (root.Modal.content && !opts.forced) return
    root.Modal.setNodeStyles({
      opacity: '1',
      visibility: 'visible',
      pointerEvents: 'auto'
    })

    await root.Modal.removeContent()
    await root.Modal.set(
      {
        extends: FoundModal,
        state: val,
        animation: 'modalIn',
        animationFillMode: 'both',
        ...opts.animationProps
        // animationDelay: 'Z'
      },
      {
        ...opts,
        bySet: true
      }
    )
  }
}

// Legacy router-driven modal closer. Renamed 2026-06-01 from `closeModal`
// to `closeRouterModal` for the same reason as the open companion above.
// Callers in shared/pages/*-modal.js (the legacy router modal page files)
// updated to use this name. The stateKey-walker variant in
// workspace/functions/index.js keeps the canonical `closeModal` name —
// it's what the brand `ModalHeader` Close button dispatches to.
export async function closeRouterModal() {
  const el = this

  // v3.14 stateKey-driven modals first: walk up from the caller (typically
  // the ModalHeader Close icon) until we find an ancestor declaring
  // `stateKey`. Clearing `root[stateKey]` (and any `extraClose` keys) is
  // the canonical close path — it flips Modal.display back to 'none' via
  // the reactive `display` factory in `shared/components/Modal.js`.
  //
  // Without this walk-up, the brand `ModalHeader.Icons.Close` button (which
  // calls `el.call('closeModal')`) hit the legacy `root.Modal`-driven path
  // below, found no `root.Modal`, and silently no-op'd — the window stayed
  // open. (#2175)
  //
  // The legacy path remains as a fallback for any element that still relies
  // on the router-driven `root.Modal` modal (e.g. canvas overlay flows).
  const root = el?.state?.root
  if (root?.update) {
    let m = el
    while (m) {
      const sk = typeof m.stateKey === 'string' ? m.stateKey : null
      if (sk) {
        const extra =
          m.extraClose && typeof m.extraClose === 'object' && !Array.isArray(m.extraClose)
            ? m.extraClose
            : null
        root.update(extra ? { [sk]: null, ...extra } : { [sk]: null })
        return
      }
      m = m.parent
    }
  }

  // Legacy `root.Modal`-driven modal (router-mounted). Preserved for any
  // canvas/preview surfaces still using the old Modal renderer.
  const Modal = el.getModal()

  delete this.getRootState().activeModal

  Modal?.setNodeStyles({
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none'
  })

  await Modal?.content?.update({
    animation: 'modalOut',
    animationDuration: '0',
    animationDelay: '0'
  })

  const t = setTimeout(async () => {
    await el.call('removeModal')
    clearTimeout(t)
  }, 350)
}

export async function removeModal() {
  const Modal = this.getModal()

  // if (location.pathname !== '/canvas') {
  //   const { index } = this.call('findModal')
  //   const path = window.location.pathname
  //   const routes = path.slice(1).split('/').slice(0, -index)
  //   const href = '/' + routes.join('/')

  //   this.router(
  //     href,
  //     this.getRoot(),
  //     {},
  //     {
  //       scrollToTop: false,
  //       updateStateOptions: {
  //         scrollToTop: false,
  //         forceRerender: true,
  //         onlyUpdate: 'Modal'
  //       }
  //     }
  //   )
  // }

  await Modal?.removeContent()
}
